import { EnumValues } from 'src/app/helpers/enum.helper';
import { BaseMesajType, EMesajAltTipi, EMesajTipi, EUcNokta } from 'src/types/components/socket.type';

export const EMMUConnectionStatus = { 'NOT CONNECTED': 0, CONNECTED: 1, DISCONNECTED: 2, HANDSHAKED: 3 } as const;

export type MMUConnectionStatus = EnumValues<typeof EMMUConnectionStatus>;

export type SurferContext = {
  ip: string;
  port: string;
  protokol: string;
  ucNokta: EUcNokta.SUNUCU_SURFER;
};

export type ForwardingResponseType = {
  icerik?: SurferContext;
  mesajAltTipi: EMesajAltTipi.YONLENDIRME | EMesajAltTipi.UYGUN_SURFER_BULUNMUYOR;
  mesajTipi: EMesajTipi.MMU;
};

export type MMUReceivedMessageType = MMUForwardingSuccessMessage | MMUForwardingFailedMessage;

export type MMUMessage = {
  mesajTipi: EMesajTipi.MMU;
  mesajAltTipi: EMesajAltTipi;
} & BaseMesajType;

export type MMUForwardingSuccessMessage = {
  icerik: SurferContext;
  mesajAltTipi: EMesajAltTipi.YONLENDIRME;
} & MMUMessage;

export type MMUForwardingFailedMessage = {
  mesajAltTipi: EMesajAltTipi.UYGUN_SURFER_BULUNMUYOR;
} & MMUMessage;
